import {Bars} from 'react-loader-spinner'
import axios from 'axios';
import React, {useContext, useEffect, useState} from 'react';
import Chart from '../../Chart/Chart';
import {authContext} from '../../Context/Authentication/authContext';
import {baseURL} from '../../config';
import {generateChartData} from '../../Helpers/helpers'

const Rentals = () => {
  const {state}: any = useContext(authContext);
  const [chartData, setChartData]: any = useState(null);

  useEffect(() => {
    getRentals();
  }, [state.filters.years, state.filters.city,state.filters.rentalValue]);

  const getRentals = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const city = JSON.stringify(state.filters.city)
        .replace(/[\[\]']+/g, '')
        .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getRentalDataByCity?state=${state.filters.state}&city=${city}&startYear=${start}&endYear=${end}&category=${state.filters.rentalValue}`
      );
      const resp = response.data?.cube
      const data = generateChartData(resp, 'rental_index');
      setChartData(data);
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className='population-main'>
      {chartData === null ? (
        <div className='daysOnMarket-main__chartContainer__isLoading'>
          <Bars height='400' ariaLabel='bars-loading' wrapperClass='tab-spinner-progress-bar' visible={true}/>
        </div>
      ) : chartData?.length ? (
        <>
          <div className='population-main__text'>Rentals</div>
          <Chart
            chartData={chartData}
            title={'Rental Index'}
            city={state.filters.city.sort()}
          />
        </>
      ) : (
        <div className='daysOnMarket-main__chartContainer__noData'>
          No Data Available
        </div>
      )}
    </div>
  );
};

export default React.memo(Rentals);